
const getOtherUsers = function(authUser, room) {
	if(room.users) {
		return room.users.filter(x => x.id != authUser.id);
	}
	return [];
}
const getChatName = function(authUser, bubble) {
	if(bubble.is_direct) {
		return getOtherUsers(authUser, bubble)[0].name;
	}
	else if(bubble.is_public) {
		return bubble.name;
	}
	else {
		let n = '';
		let cnt = 0;
		const users = getOtherUsers(authUser, bubble);
		users.forEach(x => {
			if(x.name) {
				if(cnt <= 2) {
					cnt += 1;
					if(cnt != 1) {
						n += ', '
					}
					n += x.name;
				}
			}
		});

		if(cnt < users.length) {
			return n + ' +' + (users.length - cnt) + ' innych'
		}
		return n;
	}
}

export {getOtherUsers, getChatName};
